import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '海南裕达科技股份有限公司 - 官网'
          }
        }, {
          path: '/',
          name: '',
          component: resolve => require(['@/view/solution'], resolve),
          meta: {
            title: '解决方案'
          },
          children: [
            {
              path: '/solution/dinnerCloud',
              name: 'dinnerCloud',
              component: resolve => require(['@/view/solution/dinnerCloud'], resolve),
              meta: {
                title: '云食堂综合管理方案'
              }
            },
            {
              path: '/solution/eBusiness',
              name: 'eBusiness',
              component: resolve => require(['@/view/solution/eBusiness'], resolve),
              meta: {
                title: '电商方案'
              }
            },
            {
              path: '/solution/eEducation',
              name: 'eEducation',
              component: resolve => require(['@/view/solution/eEducation'], resolve),
              meta: {
                title: '教育平台方案'
              }
            },
            {
              path: '/solution/blockchain',
              name: 'solution',
              component: resolve => require(['@/view/solution/blockchain'], resolve),
              meta: {
                title: '区块链食品追溯方案'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/newsinformation/business',
          name: 'newsinformation-business',
          component: resolve => require(['@/view/NewsInformation_business'], resolve),
          meta: {
            title: '行业动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '关于我们'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/joinus',
          name: 'joinus',
          component: resolve => require(['@/view/JoinUs'], resolve),
          meta: {
            title: '加入我们'
          }
        },
        {
          path: '/newsinformation/1',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_1'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/2',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_2'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/3',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_3'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/4',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_4'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/5',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_5'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/6',
          name: 'newsinformation',
          component: resolve => require(['@/view/CompanyNews/news_6'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/1',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_1'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/2',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_2'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/3',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_3'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/4',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_4'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/5',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_5'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/newsinformation/business/6',
          name: 'newsinformation',
          component: resolve => require(['@/view/IndustryNews/news_6'], resolve),
          meta: {
            title: '新闻动态'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js